// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"718ad911","787":"a6a84006"}[chunkId] + ".chunk.js";
};